import { render, staticRenderFns } from "./LeadItemFull.vue?vue&type=template&id=390e8c93&"
import script from "./LeadItemFull.vue?vue&type=script&lang=ts&"
export * from "./LeadItemFull.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports